export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const POSTAL_CODE_REGEX =
  /^(?=.{3,12}$)(?!.*[^A-Za-z0-9\s-])(?!.*[-\s]{2,})(?![-\s])[A-Za-z0-9](?:[A-Za-z0-9]|[-\s](?=[A-Za-z0-9]))*[A-Za-z0-9]$/
